/** @type {import('./constants').TLocale[]} */
const LOCALES = ['fr', 'en', 'es', 'pt', 'it', 'pl']

module.exports = LOCALES
